import { useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";

export const LegalModal = ({ doc, onClose }) => {
  useEffect(() => {
    if (!doc) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doc]);

  if (!doc) return null;

  return (
    <motion.div
      data-testid="legal-modal"
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/85 backdrop-blur-sm px-4 py-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      onClick={onClose}
    >
      <motion.div
        className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-[#0C0C0C] border border-[#C5A059]/40 p-8 md:p-12"
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="legal-close"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-5 right-5 text-zinc-500 hover:text-[#C5A059] transition-colors duration-300"
        >
          <X size={20} />
        </button>

        <h2 className="font-serif text-3xl md:text-4xl text-white pr-8">{doc.title}</h2>
        <p className="mt-2 text-[0.7rem] uppercase tracking-[0.3em] text-[#C5A059]">{doc.updated}</p>

        <div className="mt-10 space-y-8">
          {doc.sections.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(0.15 + i * 0.06, 0.6), duration: 0.5 }}
            >
              <h3 className="font-serif text-lg text-[#C5A059] italic">{s.h}</h3>
              {/* El contrato trae saltos de línea propios: se respetan tal cual. */}
              <p className="mt-2 text-sm text-zinc-400 font-light leading-relaxed whitespace-pre-line">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};
